import { render, staticRenderFns } from "./r-talk-page.vue?vue&type=template&id=cfbd5da6"
import script from "./r-talk-page.vue?vue&type=script&lang=js"
export * from "./r-talk-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfbd5da6')) {
      api.createRecord('cfbd5da6', component.options)
    } else {
      api.reload('cfbd5da6', component.options)
    }
    module.hot.accept("./r-talk-page.vue?vue&type=template&id=cfbd5da6", function () {
      api.rerender('cfbd5da6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/talk/r-talk-page.vue"
export default component.exports